module.exports = __webpack_public_path__ + "img/clock_no.2570202f.jpg";